
const ACTION_ADD_BLUEPRINT = 'blueprints.add';
const ACTION_DEL_BLUEPRINT = 'blueprints.del';
const ACTION_UPDATE = 'blueprint.update';

export function addBlueprint(bp) {
  return {
    type: ACTION_ADD_BLUEPRINT,
    payload: {
      ...bp
    }
  };
}

export function deleteBlueprint(id) {
  return {
    type: ACTION_DEL_BLUEPRINT,
    payload: {
      ID: id
    }
  };
}

export function updateBlueprint(id, props) {
  return {
    type: ACTION_UPDATE,
    payload: {
      ID: id,
      props: props
    }
  };
}

const reducer = function(state = [], action) {
  switch (action.type) {
    case ACTION_ADD_BLUEPRINT:
      return [...state, action.payload];

    case ACTION_DEL_BLUEPRINT:
      return state.filter((bp) => bp.ID !== action.payload.ID);

    case ACTION_UPDATE:
      return state.map((bp) => {
        if (bp.ID !== action.payload.ID) return bp;
        return {...bp, ...action.payload.props};
      });

    default:
      return state;
  }
}

export default reducer;
